import { render, staticRenderFns } from "./hardwareSix.vue?vue&type=template&id=60ed117f&scoped=true"
import script from "./hardwareSix.vue?vue&type=script&lang=js"
export * from "./hardwareSix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed117f",
  null
  
)

export default component.exports